import React from 'react';
import { Grid } from '@mui/material';
import { OrderScenarioLabels } from 'components/order/model/Order';
import { getCurrencyString } from 'lib/helpers';
import { CardViewTextRow } from 'ui/viewComponents';
import { isOrderPaymentRefundedAction } from '../models/Action';
import { getActionDate } from '../utils/formatDate';
import { ActionCardBase } from './ActionCardBase';
import { ActionCardModalComponentProps } from './ActionCardModalComponent';

export const ActionCardOrderPaymentRefunded: React.FC<ActionCardModalComponentProps> = ({ action }) => {
    if (!isOrderPaymentRefundedAction(action)) {
        return <ActionCardBase action={action} broken />;
    }
    return (
        <ActionCardBase action={action} size="double">
            <Grid container spacing={1}>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6
                    }}
                >
                    <CardViewTextRow title="Date" value={getActionDate(action)} />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6
                    }}
                >
                    <CardViewTextRow title="Location" value={action.context.location.title} />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6
                    }}
                >
                    <CardViewTextRow title="Currency" value={action.metadata.value.currency} />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6
                    }}
                >
                    <CardViewTextRow
                        title="Amount"
                        value={getCurrencyString(
                            action.metadata.value.amount,
                            action.metadata.value.currency
                        )}
                    />
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6
                    }}
                >
                    <CardViewTextRow
                        title="Type"
                        value={OrderScenarioLabels[action.metadata?.order?.scenario]}
                    />
                </Grid>
            </Grid>
        </ActionCardBase>
    );
};
